module.exports = __webpack_public_path__ + "static/media/A.a1c8df69.png";